<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage
        :form-open="formOpen"
        :page-titles="pageTitles"
        @onClick="abrirForm"
      />
      <div v-if="formOpen">
        <produtoForm :produto="produto" :keyindex="keyIndex" :salvar="salvar" @previewFiles="previewFiles" :formsubmit="formsubmit" />
      </div>
      <div v-else>
        <Table
          :search="true"
          :form-open="formOpen"
          :tables-fields="produtosFields"
          :table-items="produtos"
          @onEdit="edit"
          @onDelete="onDelete"
        />
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import produtoForm from '../../../../components/forms/produtoForm.vue'
import Table from '@/src/components/tables/table-register.vue'
import alertMixin from '@/src/mixins/alertMixin'
import produtoMixin from '@/src/mixins/produtoMixin'

export default {
  components: { Layout, HeaderPage, produtoForm, Table },
  mixins: [alertMixin, produtoMixin],
  data() {
    return {
      isLoading: false,
      pageTitles: {
        title: 'Cadastro De Produtos',
        subtitle: 'Registre seus produtos aqui',
      },
      formOpen: false,
      item: '',
      produto: {},
      produtos: [],
      formsubmit: false,
      keyIndex: 0,
    }
  },
  mounted() {
    this.listaProduto()
  },
  methods: {
    previewFiles(e) {
      console.log(e.target.files);
      this.isLoading = true
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      this.uploadImage(formData).then((response) => {
        this.produto.imagem = response.data.dados.url;
        this.keyIndex += 1
      }).finally(()=>{
        this.isLoading = false
        this.isUpload = false
        this.photo = null
      })
    },
    abrirForm() {
      this.formOpen = !this.formOpen
      this.produto = {}
      this.formsubmit = false
    },
    listaProduto() {
      this.isLoading = true
      this.loadProdutos().then((res) => {
        this.produtos = res.data.dados
        this.isLoading = false
      })
    },
    edit(item) {
      this.abrirForm()
      this.produto = item
    },
    salvar() {
      this.isLoading = true
      if (!this.produto._id) {
        this.registerProduto(this.produto)
          .then((response) => {
            this.successMessage(response.data.message?response.data.message:'Cadastrado com sucesso')
            this.abrirForm()
            this.produto = {}
            this.listaProduto()
            this.isLoading = false
          })
          .catch((err) => {
            this.errorMessage(err.response.data.mensagem?err.response.data.mensagem:'Erro inesperado.')
            this.isLoading = false
          })
      } else {
        delete this.produto['senha']
        this.editProduto(this.produto._id, this.produto).then((res) => {
          this.successMessage(res.data.message?res.data.message:'produto atualizado com Sucesso')
          this.abrirForm()
          this.produto = {}
          this.listaProduto()
          this.isLoading = false
        })
        .catch((err) => {
          this.errorMessage(err.response.data.mensagem?err.response.data.mensagem:'Erro inesperado.')
          this.isLoading = false
        })
      }
    },
    onDelete(id) {
      this.isLoading = true
      this.deleteProduto(id).then(()=>{
        this.successMessage('produto removido com sucesso')
        this.listaProduto()
        this.produto = {}
        this.isLoading = true
      }) 
    },
  },
}
</script>
<style src="../style.scss" lang="scss"></style>
